export var Journeys = {
  GET_STARTED: 'get-started',
  DECIDE: 'decide',
  DISCOVER: 'discover'
};
export var Targets = {
  CONFLUENCE: 'confluence.ondemand',
  JIRA_CORE: 'jira-core.ondemand',
  JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
  JIRA_SOFTWARE: 'jira-software.ondemand',
  JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
  BITBUCKET: 'bitbucket.ondemand',
  TRELLO: 'trello',
  OPSGENIE: 'opsgenie',
  STATUSPAGE: 'statuspage',
  /**
   * @private
   * @deprecated Use ATLAS instead
   */
  TEAM_CENTRAL: 'townsquare',
  ATLAS: 'townsquare',
  /**
   * @private
   * @deprecated
   */
  AVOCADO: 'avocado',
  ANALYTICS: 'atlassian-analytics-free',
  COMPASS: 'compass'
};
export var Reasons = {
  NO_API_SUPPORT: 'Could not provide requested API version',
  NO_PROVIDER: 'Provider not found'
};

// equivalent of `typeof Reason.NO_API_SUPPORT | typeof Reason.NO_PROVIDER | ...`